import React, { FC } from 'react'
import { FooterGenericNavProps, MenuType } from '../Footer.types'
import {
  APIENDPOINT,
  getCWPEnvironmentForURL,
  sanitizeHTML,
} from '../../../../common/utils/common-utils'
import { useFetch } from '../../../../common/utils/hooks'
import './footer-generic-nav.scss'

export const FooterGenericNav: FC<FooterGenericNavProps> = props => {
  const { menuName, disclaimerContent, copyrightLine } = props
  const env = getCWPEnvironmentForURL(window.location.href)
  const footerMenuUrl = `${APIENDPOINT(env).menuBaseWithParams}${menuName}`
  const footerMenu = useFetch(footerMenuUrl)
  const { data } = footerMenu as unknown as MenuType
  const { menuItems } = data
  return (
    <div className='u-sizeConstrained'>
      <ul className='Grid Grid--withGutter u-md-flexCol u-sm-flexCol u-paddingVert4gu u-flexNoWrap'>
        {menuItems?.map((item, index) => {
          return (
            <li
              className={`u-lg-sizeFit u-size6of6 u-marginVert2gu ${
                index !== menuItems.length - 1 ? 'u-borderColorNeutral50 ' : ''
              }u-flex u-flexAlignItemsCenter u-sm-borderRight0 u-md-borderRight0`}
              key={item.HstMenuItemRepresentation.name}>
              <a className='u-textColorLight u-linkClean' href={item.HstMenuItemRepresentation.url}>
                {item.HstMenuItemRepresentation.name}
              </a>
            </li>
          )
        })}
      </ul>
      <div
        className='Content Content--legal u-paddingBottom4gu'
        dangerouslySetInnerHTML={{ __html: sanitizeHTML(disclaimerContent) }}
      />
      <div className='Content Content--legal'>
        <p className='u-textSizeMsrm1'>&#169; {`${new Date().getFullYear()} ${copyrightLine}`}</p>
      </div>
    </div>
  )
}
